<template>
  <div
    class="doctor-list-main-wrapper cbg-white-container input-container theme--light v-card p-16 border-card"
  >
    <CRow>
      <CCol sm="12">
        <CRow>
          <CCol sm="6" md="3">
            <div class="common-search position-relative">
              <CInput label="Search by Name" v-model="search" placeholder="Name" />
              <div
                v-if="search !== ''"
                class="cross-svg center-cross-svg position-absolute"
                @click="clearSearch()"
              >
                <crossSVG />
              </div>
            </div>
          </CCol>
          <CCol sm="6" md="3">
            <label for>Per Page</label>
            <v-select v-model="recordPerPage" :items="perPageOptions" outlined hide-details />
          </CCol>
          <v-col cols="12" md="3" sm="6">
            <label class="col-sm-12 mb-0 d-none-mob"></label>
            <v-btn class="btn btn-primary mr-4" @click="getDoctorTest()">Search</v-btn>
          </v-col>
        </CRow>
      </CCol>
      <CCol sm="12">
        <table class="table">
          <thead>
            <tr class="table-success">
              <th scope="col">Name</th>
              <!-- <th scope="col">Date</th> -->
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="test in doctorTest" :key="test.id">
              <td>{{ test.name }}</td>
              <!-- <td>{{ test.created_at}}</td> -->
              <td>
                <CRow>
                  <CCol xl class="mb-3 mb-xl-0">
                    <div v-if="test.status == null">
                      <CButton
                        variant="outline"
                        color="success"
                        @click="addTestModal(test), (action = 'Add')"
                        v-if="
                          permissions.includes(
                            'CAN_ADD_DOCTOR_DOCSMART_TESTS_MASTER'
                          )
                        "
                      >Add to Master</CButton>
                      <CButton
                        variant="outline"
                        color="danger"
                        @click="rejectTest(test), (action = 'Reject')"
                        v-if="
                          permissions.includes(
                            'CAN_REJECT_DOCTOR_DOCSMART_TESTS_MASTER'
                          )
                        "
                        class="ml-2"
                      >Reject</CButton>
                    </div>
                    <div v-else>
                      <td>
                        {{
                        test.status == 1
                        ? "Added to master"
                        : "Not adeed to master"
                        }}
                      </td>
                    </div>
                  </CCol>
                </CRow>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          class="pagination-block"
          :recordPerPage="recordPerPage"
          :currentPage="currentPage"
          :total="total"
          @changePage="changePage"
        />
      </CCol>
    </CRow>
    <add-edit-test
      v-if="addEditTestModal"
      :test="test"
      :action="action"
      :show="addEditTestModal"
      @close="addEditTestModal = false"
      @submit="addTest"
    />
  </div>
</template>
<script>
import { pickSvg } from "@/views/SVG";
import config from "@/config.js";
import { mapGetters } from "vuex";
import AddEditTest from "@/views/master/AddEditTest";
export default {
  data() {
    return {
      action: "",
      perPageOptions: [10, 20, 30, 50, 100],
      recordPerPage: 10,
      search: "",
      currentPage: 1,
      doctorTest: [],
      addEditTestModal: false,
      test: {},
      doctorTestId: null,
      total: 0
    };
  },
  components: {
    AddEditTest,
    ...pickSvg("crossSVG"),
    pagination: () => import("@/views/common/Pagination")
  },

  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },

  methods: {
    addTestModal(val) {
      this.test = {
        name: val.name,
        cost: null,
        report_by_day: null,
        category: "Regular",
        fasting: 0,
        advice: null,
        home_service: 0,
        type: ""
      };
      this.doctorTestId = val.id;
      this.addEditTestModal = true;
      this.action = "Add";
    },
    getDoctorTest() {
      let url = `${config.DIAGNOSTICS_URL}api/v1/admin/doctor-test`;
      let payload = {
        search_text: this.search,
        page: this.currentPage,
        records_per_page: this.recordPerPage
      };
      this.$http.get(url, { params: payload }).then(res => {
        if (res.body.status) {
          this.doctorTest = res.body.data.data;
          this.total = res.body.data.total;
        }
      });
    },
    addTest(val) {
      let url = `${config.DIAGNOSTICS_URL}api/v1/admin/doctor-test-add`;
      let params = { test: this.test, doctorTestId: this.doctorTestId };
      this.$http.post(url, params).then(res => {
        if (res.data.status) {
          this.getDoctorTest();
          this.addEditTestModal = false;
          this.$swal({
            text: "Test Added sucessfully",
            icon: "success",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "Ok"
          });
        }
      });
    },
    rejectTest(val) {
      this.$swal({
        title: "Are you sure?",
        text: "you want to reject this test from master list!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          let url =
            `${config.DIAGNOSTICS_URL}api/v1/admin/doctor-test/` + val.id;
          this.$http.delete(url).then(res => {
            if (res.data.status) {
              this.$swal({
                text: "Test rejected sucessfully",
                icon: "success",
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonText: "Ok"
              });
              this.getDoctorTest();
            }
          });
        }
      });
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getDoctorTest();
    }
  },

  created() {
    this.getDoctorTest();
  }
};
</script>
